module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Project Details")]), _vm._v(" "), _c('table', {
    staticClass: "table projectLists"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.projects), function(project) {
    return _c('tr', {
      key: project.projectID,
      class: {
        'lockedRow': project.IsLocked
      }
    }, [_c('td', [_vm._v(_vm._s(project.projectID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.projectName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("projectTypeMap")(project.projectType)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.lastUpdate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.updateBy))]), _vm._v(" "), _c('td', [(project.projectType === 1) ? _c('router-link', {
      attrs: {
        "activeClass": "active",
        "tag": "a",
        "to": {
          name: 'pgnatConfig',
          query: {
            projectID: project.projectID,
            cipID: _vm.cipID
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "title": "Edit project"
      }
    }, [(!project.IsLocked) ? [_vm._v("Edit")] : [_vm._v("Preview")]], 2)]) : _vm._e(), _vm._v(" "), (project.projectType === 2) ? _c('router-link', {
      attrs: {
        "activeClass": "active",
        "tag": "a",
        "to": {
          name: 'gnatConfig',
          query: {
            projectID: project.projectID,
            cipID: _vm.cipID
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "title": "Edit project"
      }
    }, [(!project.IsLocked) ? [_vm._v("Edit")] : [_vm._v("Preview")]], 2)]) : _vm._e(), _vm._v(" "), (project.projectType === 3) ? _c('router-link', {
      attrs: {
        "activeClass": "active",
        "tag": "a",
        "to": {
          name: 'aptConfig',
          query: {
            projectID: project.projectID,
            cipID: _vm.cipID
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "title": "Edit project"
      }
    }, [(!project.IsLocked) ? [_vm._v("Edit")] : [_vm._v("Preview")]], 2)]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "title": "Duplicate project"
      },
      on: {
        "click": function($event) {
          return _vm.copyProject(project)
        }
      }
    }, [_vm._v("Copy")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "title": "Test project"
      },
      on: {
        "click": function($event) {
          return _vm.testProject(project)
        }
      }
    }, [_vm._v("Test")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-warning",
      attrs: {
        "disabled": project.IsLocked,
        "title": "Delete project"
      },
      on: {
        "click": function($event) {
          return _vm.deleteProject(project.projectID)
        }
      }
    }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "title": project.IsLocked ? 'Unlock project' : 'Lock project'
      },
      on: {
        "click": function($event) {
          return _vm.lockUnlockProject(project.projectID, project.IsLocked)
        }
      }
    }, [(!project.IsLocked) ? [_vm._v("Lock")] : [_vm._v("Unlock")]], 2)], 1)])
  }), 0)]), _vm._v(" "), (_vm.showConfirmationModal) ? _c('div', {
    staticClass: "modal modal--confirmation fade",
    class: {
      in: _vm.showConfirmationModal
    },
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "confirmationModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.showConfirmationModal = false
      }
    }
  }, [_vm._v("\n            ×\n            ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "confirmationModalLabel"
    }
  }, [_vm._v("\n            Unlock a project\n            ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.showConfirmationModal = false
      }
    }
  }, [_vm._v("\n            No\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.lockUnlockProjectTrigger(_vm.unlockProjectId, true)
      }
    }
  }, [_vm._v("\n            Yes\n            ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmationModal),
      expression: "showConfirmationModal"
    }],
    staticClass: "modal-backdrop fade",
    class: {
      in: _vm.showConfirmationModal
    },
    on: {
      "click": function($event) {
        _vm.showConfirmationModal = false
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "col-sm-1"
  }, [_vm._v("ID")]), _vm._v(" "), _c('td', {
    staticClass: "col-sm-4"
  }, [_vm._v("Name")]), _vm._v(" "), _c('td', {
    staticClass: "col-sm-1"
  }, [_vm._v("Type")]), _vm._v(" "), _c('td', {
    staticClass: "col-sm-1"
  }, [_vm._v("Last Update")]), _vm._v(" "), _c('td', {
    staticClass: "col-sm-2"
  }, [_vm._v("Updated By")]), _vm._v(" "), _c('td', {
    staticClass: "col-sm-3"
  }, [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Do you have approval to unlock this project and make changes?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31b75138","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projectLists/ProjectList.vue
// module id = 44
// module chunks = 0